import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducer";
import { setShop as setShopAction } from "../../redux/slices/ShopSlice";

const useShop = () => {
  const dispatch = useDispatch();

  const shop = useSelector((state: RootState) => {
    const { Shop } = state;

    return Shop;
  });

  const setShop = useCallback(
    (param: string) => {
      dispatch(setShopAction(param));
    },
    [dispatch]
  );

  return { shop, setShop };
};

export default useShop;
